const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/jc305/admin',
      name: 'proc_jc305_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/jc305/appl',
      name: 'proc_jc305_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/jc305/router.js